import { useTheme } from "@mui/material/styles";
import type { SxProps, Theme } from "@mui/system";
import { OcRoleFilterItemData } from "../role-filter/role-filter.types";

interface UseOcRoleFilterSubtypeCollapseProps {
  noCode?: boolean;
  availableItems: OcRoleFilterItemData[];
  dataTotal: number;
  type: string;
  editable?: boolean;
}

export const useOcRoleFilterSubtypeCollapse = ({
  availableItems,
  dataTotal,
  type,
  noCode,
  editable,
}: UseOcRoleFilterSubtypeCollapseProps) => {
  const theme = useTheme();

  const generateLabel = (item: OcRoleFilterItemData): string => {
    if (noCode) return item.name;
    let returnString = item.name;
    const hasCode = item.code.replaceAll(/\s/g, ""); // Removes whitespaces.
    if (hasCode) returnString += ` (${item.code})`;
    return returnString;
  };

  const dataLength = availableItems.length;
  const hasMore = availableItems.length < dataTotal;
  const availableListId = `oc-role-filter-collapse-${type}-available-items-list`;

  let boxCss: SxProps<Theme> = {
    maxHeight: "180px",
    overflowY: "auto",
    padding: "16px 8px 0px",
  };

  if (editable)
    boxCss = {
      border: `1px solid ${theme.palette.gray40.main}`,
      borderRadius: "4px",
      backgroundColor: theme.palette.white.main,
      maxHeight: "180px",
      overflowY: "auto",
      padding: "8px",
    };

  return {
    generateLabel,
    dataLength,
    hasMore,
    availableListId,
    boxCss,
  };
};
